import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GeneralSnackComponent } from '../components-generals/general-snack/general-snack.component';

export class SnackAlertError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SnackAlertError';
  }
}

@Injectable({
  providedIn: 'root',
})
export class GeneralSnackService {
  constructor(private matSnackBar: MatSnackBar) {}

  public async viewSnacAlert(text: string, type: 'normal' | 'error' | 'alert', tilule: string) {
    this.matSnackBar.openFromComponent(GeneralSnackComponent, {
      duration: 5000,
      panelClass: ['panel-snack-general'],
      data: {
        type: type,
        icon: 'close',
        text: tilule,
        suptext: text,
        body: true,
      },
    });
  }

  public throwErrorAlert(text: string, tilule = 'Error'): never {
    void this.viewSnacAlert(text, 'error', tilule);
    throw new SnackAlertError(text);
  }
}
